<ion-card mode="ios" class="team-card limited-card-col">
    <ion-card-header color="">
        <ion-searchbar mode="ios"
                       class="section-search-custom"
                       [placeholder]="'generic.searchByName' | translate"
                       (keyup)="updateSearch($event.target.value)">
        </ion-searchbar>
    </ion-card-header>

    <ion-card-content class="ion-no-padding">
        <ion-grid class="team">
            <ion-row *ngFor="let user of displayedUsers"
                     [ngClass]="{ 'selected': selectedUserId === user.userId }">
                <ion-col size="1.5">
                    <img [src]="getImageUrl(user.imageUrl)" default="" class="avatar">
                </ion-col>
                <ion-col size="4.5">
                    <h3 [ngClass]="{'selected-user-label': selectedUserId === user.userId}" [ngClass]="{ 'selected': selectedUserId === user.userId }" >{{ user.name }}</h3>
                  <span>
            {{user.isReopenedByRefusal? ('processParticipants.reopenedByRefusal' | translate) : ''}}
          </span>
        </ion-col>
                <ion-col size="6" flexed>
                    <p class="selected-user-label" *ngIf="selectedUserId === user.userId">
                        <ion-button text-wrap mode="ios"
                fill="outline" expand="block"  style="color: #fff;--opacity: 1;" disabled>
                {{ 'generic.selected' | translate }}
                      </ion-button>
            
          </p>
                    <ng-container *ngIf="!selectedUserId || selectedUserId !== user.userId">
                        <ng-container *ngIf="user.isBlocked" >
                <p style="cursor: default;color: #d35828;"
                  color="warning" fill="clear" expand="block" >
                  {{ 'login.userBlocked' | translate }}
                </p>
            </ng-container>

            <ng-container *ngIf="user.status < ProcessStatus.AllowedViewing && !user.isBlocked">
                            <ion-button text-wrap mode="ios" style="cursor: default;"
                                        color="warning" fill="clear" expand="block">
                                {{ 'generic.NotSent' | translate }}
                            </ion-button>
                        </ng-container>

            <ng-container *ngIf="user.status === ProcessStatus.AllowedViewingWithWarnings && !user.isBlocked" >
              <ion-button text-wrap mode="ios" expand="block"
                *ngIf="selectedUserId !== user.userId" 
                (click)="setUser(user)"
                [disabled]="user.isReopeningExpired"
                [title]="user.isReopeningExpired ? ('processParticipants.reopenExpired' | translate) : ''"
                >
                {{user.isReopeningExpired ? ('processParticipants.reopenExpired' | translate) : ('360evaluation.seeEvaluators' | translate)}}
              </ion-button>
            </ng-container >

                        <ng-container *ngIf="user.status === ProcessStatus.AllowedViewing">
                            <ion-button text-wrap mode="ios" expand="block"
                                        *ngIf="selectedUserId !== user.userId"
                                        (click)="setUser(user)">
                                {{ 'dashboard.See' | translate }}
                            </ion-button>
                            <ion-button text-wrap mode="ios"
                                        color="success" fill="clear" expand="block">
                                {{ 'generic.validated' | translate }}
                                <ion-icon slot="end" class="bp-check"></ion-icon>
                            </ion-button>
                            <ion-button text-wrap mode="ios" expand="block"
                                        *ngIf="selectedUserId !== user.userId && isAllowedToReopen"
                                        (click)="reopenEvaluation(user)"
                [disabled]="user.isReopeningExpired"
                [title]="user.isReopeningExpired ? ('processParticipants.reopenExpired' | translate) : ''"
                >
                                {{ 'processParticipants.reopen' | translate }}
                            </ion-button>
                        </ng-container>
                    </ng-container>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card-content>
</ion-card>